import {
  LAMPORTS_PER_SOL,
  PublicKey,
  SystemProgram,
  Transaction,
} from '@solana/web3.js';

export const transactionHandler = async (
  senderPubKey: PublicKey,
  receiverPubKey: PublicKey,
  tokens: string
) => {
  //   if (!process.env.REACT_APP_ADMIN_PUB_KEY) {
  //     return;
  //   }
  //   const RECEIVER_PUB_KEY = new PublicKey(process.env.REACT_APP_ADMIN_PUB_KEY);
  try {
    const transferInstruction = SystemProgram.transfer({
      fromPubkey: senderPubKey,
      toPubkey: receiverPubKey,
      lamports: +tokens * LAMPORTS_PER_SOL,
    });

    const transaction = new Transaction().add(transferInstruction);
    if (transaction) {
      return transaction;
    } else {
      return null;
    }
  } catch (error) {
    throw new Error('Transaction failed.');
  }
};
